import "./Input.style.css";

import React from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  ref?: React.RefObject<HTMLInputElement | null>;
}

export const Input: React.FC<InputProps> = ({
  className = "",
  ref,
  ...rest
}: InputProps) => {
  const baseClasses = `input_field ${className}`;
  const inputClasses = `${baseClasses}`.trim().replace(/\s+/g, " ");

  return <input className={inputClasses} ref={ref} {...rest} />;
};
